import PropTypes from 'prop-types';

import { ITALIC_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { ITALIC_TAG_NAME } from './constants';

const Italic = ({ className, ITALIC_TAG = ITALIC_TAG_NAME, ...attributes }) => {
  const RenderLeaf = ({ children, leaf, attributes: elementAttributes }) => {
    if (leaf[ITALIC_DEFINITIONS.type]) {
      return (
        <ITALIC_TAG
          {...attributes}
          {...elementAttributes}
          className={className}
        >
          {children}
        </ITALIC_TAG>
      );
    }
    return children;
  };
  return RenderLeaf;
};

Italic.propTypes = {
  children: PropTypes.node.isRequired,
  leaf: PropTypes.string,
};

export { Italic };
